import React, { useCallback, useEffect } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { UpgradeView } from '../common/plus_components'
import { getLocale } from '../lib/locale'
import { FixedLangProvider } from '../lib/i18n'
import { trackCheckout } from '../lib/tracking'

const Wrapper = styled.div`
    background: #1a1d23;
    min-height: 100vh;
`

const Container = styled.div`
    max-width: 530px;
    margin: 0 auto;
    padding: 0 2rem 1.5rem;
    position: relative;
`

const openCheckoutExternal = (plan) => {
    trackCheckout(plan)
    window.postMessage({ event: 'redirect', url: `${window.location.origin}/?checkout=${plan}` }, '*')
}

const PlusPage = () => {
    const query = new URLSearchParams(useLocation().search)
    const autoCheckout = query.get('checkout')
    const locale = getLocale(query.get('locale'))

    useEffect(() => {
        document.documentElement.lang = locale.lang
    }, [locale.lang])

    useEffect(() => {
        if (autoCheckout === 'monthly' || autoCheckout === 'yearly') {
            openCheckoutExternal(autoCheckout)
        }
    }, [autoCheckout])

    const openCheckout = useCallback((url, plan) => (e) => {
        e.preventDefault()
        openCheckoutExternal(plan)
    }, [])

    return <FixedLangProvider lang={locale.lang}>
        <Wrapper>
            <Container>
                <UpgradeView onCheckout={openCheckout} standalone locale={locale} isAppEmbed />
            </Container>
        </Wrapper>
    </FixedLangProvider>
}

export default PlusPage
